<template>
  <div class="stm-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>I ∝ e^(-2κd)$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Atomic Surface -->
          <g v-for="i in 10" :key="'atom'+i">
             <circle :cx="50 + i*30" :cy="180 + Math.sin(i*0.8 + offset)*5" r="12" fill="#888" opacity="0.6" />
          </g>

          <!-- The Probe Tip -->
          <g :transform="`translate(${probeX}, ${probeY})`">
             <path d="M -10,-100 L 0,0 L 10,-100 Z" fill="#333" stroke="#ffd700" />
             <text x="5" y="-30" fill="#ffd700" font-size="8">探针</text>
          </g>

          <!-- Tunneling Current Visualization -->
          <g v-if="current > 0">
             <line :x1="probeX" :y1="probeY" :x2="probeX" :y2="surfaceY" stroke="#ffd700" :stroke-width="current * 10" opacity="0.6">
                <animate attributeName="opacity" values="0.2;0.8;0.2" dur="0.2s" repeatCount="indefinite" />
             </line>
          </g>

          <!-- Current Meter -->
          <rect x="320" y="20" width="60" height="40" rx="4" fill="#111" />
          <text x="350" y="45" text-anchor="middle" fill="#ffd700" font-size="12">{{ (current*100).toFixed(1) }} nA</text>
          <text x="350" y="55" text-anchor="middle" fill="#888" font-size="8">隧穿电流</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电流对间距 d 极度敏感</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>控制探针水平扫描 (X)</label>
             <el-slider v-model="probeX" :min="50" :max="350" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>调节探针高度 (d)</label>
             <el-slider v-model="probeY" :min="120" :max="170" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>STM 利用了量子力学中的**隧穿效应**。当探针极其靠近表面时，即使不接触，电子也有几率穿越势垒形成电流。由于电流随距离呈指数级变化，探针能以**原子级精度**描绘表面起伏，是人类首次“看到”原子的工具。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScanningTunnelingViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      probeX: 200,
      probeY: 150,
      offset: 0
    }
  },
  computed: {
    surfaceY() {
       // Find which atom index we are over
       let idx = Math.round((this.probeX - 50) / 30);
       return 180 + Math.sin(idx*0.8)*5 - 12; // Radius
    },
    current() {
       let d = this.surfaceY - this.probeY;
       if (d < 0) return 1;
       return Math.exp(-d * 0.15); // Exponential decay
    }
  }
}
</script>

<style scoped lang="scss">
.stm-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
